import React, { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingButton from "@material-ui/lab/LoadingButton/LoadingButton";
import Button from "@material-ui/core/Button";

import { useParams, useLocation, useHistory } from "react-router-dom";
// import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { toMomentString } from "config/util";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Modal,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Alert,
  Row,
  Spinner,
} from "reactstrap";

import Fab from "Screen/Components/Basic/fab";

import { initReactI18next, useTranslation } from "react-i18next";

import validator from "validator";

import moment from "moment/moment";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import ReactDatetime from "react-datetime";

import { toValueLabel } from "Screen/Components/Basic/util";
import { t } from "../../services/i18n/index";

const AccountsAuthModal = ({
  loading,
  modal,
  close_modal,
  next_modal,
  accounts_auth_type,
  accounts,
  dispatch_danger,
  dispatch_put_accounts,
}) => {
  const [t, i18n] = useTranslation();
  const maps = useSelector((state) => state.reduce_get_maps);
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  const [mail_address, set_mail_address] = useState(accounts.mail_address);
  const [password, set_password] = useState("");
  const [password_confirm, set_password_confirm] = useState("");

  const [country_code, set_country_code] = useState(accounts.country_code);
  const [phone_number, set_phone_number] = useState(accounts.phone_number);
  const [phone_number_international, set_phone_number_international] = useState(
    ""
  );

  const [display_name, set_display_name] = useState(accounts.display_name);

  const [birthday, set_birthday] = useState(
    accounts.birthday ? accounts.birthday : null
  );
  const [postal_code, set_postal_code] = useState(accounts.postal_code);
  const [prefectures, set_prefectures] = useState(
    `${accounts.prefectures == 0 ? "" : accounts.prefectures}`
  );
  const [address01, set_address01] = useState(accounts.address01);
  const [address02, set_address02] = useState(accounts.address02);

  return (
    <>
      <Modal
        className="modal-dialog-centered"
        size="md"
        isOpen={modal}
        toggle={() => {
          close_modal();
        }}
      >
        <div className="modal-header justify-content-center pb-0">
          <h4 className="title title-up mt-0">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                close_modal();
              }}
            >
              <i className="nc-icon nc-simple-remove" />
            </button>

            {t("アカウント情報を変更")}
          </h4>
        </div>
        <div className="modal-body">
          <Container>
            <Row>
              <Col md="12">
                <TextField
                  value={display_name}
                  onChange={(event) => set_display_name(event.target.value)}
                  id="standard-basic"
                  label={t("お名前")}
                  style={{ width: "100%" }}
                  variant="standard"
                  margin="dense"
                />
                <KeyboardDatePicker
                  margin="dense"
                  id="date-picker-dialog"
                  label={t("生年月日")}
                  format="yyyy/MM/dd"
                  placeholder="2000/01/01"
                  value={birthday}
                  onChange={(date) => {
                    set_birthday(date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  inputVariant="standard"
                  okLabel={t("決定")}
                  cancelLabel={t("キャンセル")}
                  InputLabelProps={{ shrink: true }}
                  // variant="standard"
                  // error={false}
                  // helperText={""}
                />
                {/* <TextField
                  value={postal_code}
                  onChange={(event) => set_postal_code(event.target.value)}
                  id="standard-basic"
                  label={t("郵便番号")}
                  placeholder="1231234"
                  style={{ width: "100%" }}
                  variant="standard"
                  margin="dense"
                />
                <FormControl margin="dense" className={classes.formControl}>
                  <InputLabel id="demo-simple-select-label">
                    {t("都道府県")}
                  </InputLabel>
                  <Select
                    labelId={t("都道府県")}
                    id="demo-simple-select"
                    value={prefectures}
                    onChange={(event) => {
                      set_prefectures(event.target.value);
                    }}
                  >
                      <MenuItem
                          value={``}
                        >{`　`}
                        </MenuItem>
                    {Object.keys(maps.prefectures).map((k) => {
                      return (
                        <MenuItem
                          value={`${k}`}
                        >{`${maps.prefectures[k]}`}</MenuItem>
                      );
                    })}
                  </Select>
                </FormControl> */}
                <TextField
                  value={address01}
                  onChange={(event) => set_address01(event.target.value)}
                  id="standard-basic"
                  label={t("住所１")}
                  style={{ width: "100%" }}
                  variant="standard"
                  margin="dense"
                />
                <TextField
                  value={address02}
                  onChange={(event) => set_address02(event.target.value)}
                  id="standard-basic"
                  label={t("住所２")}
                  style={{ width: "100%" }}
                  variant="standard"
                  margin="dense"
                />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="modal-footer justify-content-center">
          <Container>
            <Row className="buttons-row">
              <Col md="6" sm="6">
                <FormGroup>
                  <LoadingButton
                    onClick={() => {
                      dispatch_put_accounts(
                        {
                          display_name,
                          birthday: toMomentString(birthday),
                          postal_code,
                          prefectures,
                          address01,
                          address02,
                        },
                        () => {
                          close_modal();
                        }
                      );
                    }}
                    pending={loading}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      width: "100%",
                      backgroundColor: primary,
                      color: "white",
                    }}
                  >
                    {t("決定")}
                  </LoadingButton>
                </FormGroup>
              </Col>
              <Col md="6" sm="6">
                <FormGroup>
                  <LoadingButton
                    onClick={() => {
                      close_modal();
                    }}
                    pending={loading}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      width: "100%",
                      // backgroundColor: primary,
                      // color: "white",
                    }}
                  >
                    {t("キャンセル")}
                  </LoadingButton>
                </FormGroup>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal>
    </>
  );
};

export default AccountsAuthModal;
